module.exports = __webpack_public_path__ + "img/icon.09c840a.png";